import '@babel/polyfill';
import 'whatwg-fetch';

import 'ol/ol.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './components/app';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import initSentry from './sentry';
import store from './store';
import theme from './styles';
import {Client as AuthClient} from '@apps-common/auth';
import {AuthProvider} from '@apps-common/auth-react';
import {DocumentHandler} from '@apps-common/auth-utils';
import {Provider} from 'react-redux';
import {Slide, ToastContainer} from 'react-toastify';
import {ThemeProvider} from '@mui/material/styles';
import {createRoot} from 'react-dom/client';

if (window.location.hostname === 'www.planet.com') {
  initSentry();
}

const authClient = new AuthClient({
  clientId: process.env.OKTA_CLIENT_ID ?? '0oa5f766sosIfhmLa4x7', // this is unique per app and they need to be registed in Okta
  redirectUri: `${window.location.origin}${window.location.pathname}`,
  postLogoutRedirectUri: `${window.location.origin}${window.location.pathname}`,
});

function navigate(rel) {
  // just update the hash back instead of window.location.replace to avoid a page refresh
  const hash = rel?.split('#') || [];
  window.location.hash = hash[1] ?? '';
}

const container = document.getElementById('root');

const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <AuthProvider client={authClient} navigate={navigate} private>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <DocumentHandler>
          <ToastContainer
            transition={Slide}
            position="top-center"
            theme="colored"
            hideProgressBar
          />
          <App />
        </DocumentHandler>
      </ThemeProvider>
    </Provider>
  </AuthProvider>
);
